/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useContext,
  useRef,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from 'react';
import _ from 'lodash-es';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { Pim } from '@mummssoftware/utils';
import { DIRECT_CARE } from '@mummssoftware/utils/constants';
import {
  DialogBox,
  VisitDialogBox,
  TaskDialogBox,
  pageStyle,
  AttributesIcon,
  HCPCSIcon,
  OverlayLoader,
} from '@mummssoftware/common-ui';
import {
  GlobalContext,
  priorVisit,
} from '@mummssoftware/global-context/GlobalContext';
import {
  CPPGlobalContext,
  CertGlobalContext,
  HopeGlobalContext,
} from '@mummssoftware/global-context';
import {
  MummsPDFGlobalContext,
  DashboardPDFDocument,
  clearPdfData,
} from '@mummssoftware/mumms-print';
import { printPDF } from '@mummssoftware/mumms-print/DashboardPDF/utils/printUtils';
import { PimMessagingContext } from '@mummssoftware/pim-messenger';
import { PrintInterfaceDialog } from '../PrintInterface/PrintInterfaceDialog';
import { EpisodeCheck } from '../VisitInterface/EpisodeCheck';
import { SIAModal } from '../HOPE/SIAModal';
import { HopeVisitWarningModal } from '../HOPE/HopeVisitWarningModal';
import { ElectionAddendumProvider } from '../ElectionAddendum/ElectionAddendumContext';
import { VisitPromptStack } from '../VisitPrompts/VisitPromptStack';
import { ElectionAddendumIcon } from '../ElectionAddendum/ElectionAddendumIcon';
import {
  SET_PRINT_INTERFACE_OPEN,
  SET_LOADER,
  SET_PRINT_LAYOUT_OPEN,
  SET_ALERT,
  SET_VISIT_ALERT,
  SET_THEME_OVERLAY,
  MINIMIZE_VISIT_DIALOG,
  SET_DISABLE_PRINT,
  SHOW_TASKS,
  clinicalDashboard,
  CompletedPDFComponents,
  PrintTheChart,
  SET_SHOW_HCPCS,
  SHOW_VISIT_LOADER,
} from '../Context/constants';
import { DashboardMain, GridDiv } from '../../components';
import { SideBar } from '../SideBar';
import { VisitInterface } from '../VisitInterface';
import { TasksIcon } from '../Tasks/TasksIcon';
import { SubmitTasks } from '../Tasks/SubmitTasks';
import { TaskPlanning } from '../Tasks/TaskPlanning';
import { DashboardPrintComponent } from '../DashboardPrint';
import { DashboardContext } from '../Context/contexts/DashboardContext';
import { VisitContext } from '../Context/contexts/VisitContext';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';
import { DashboardGridComponent } from '../DashboardGrid';
import { ThemeLoader } from '../ThemeLoader';
import { AddHCPCSDialog } from '../HCPCS/AddHCPCSDialog';
import defaults from '../../translations/en.json';
import { Context } from '../../context';
import {
  compareWidgetMenuOrder,
  renumberPatientDashboardWidgetMenuOrder,
  usePersistPatientDashboardWidgetLayout,
  clearWidgetLayoutDraft,
  getWidgetLayoutDraftKey,
} from '../Context/widgetConfig';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { IDGRenderDialog } from '../IDGRenderDialog/IDGRenderDialog';

type DashboardProps = {
  config: mumms.WidgetConfig[];
  resolveUserNonRoleWidgets?: mumms.WidgetConfig[];
  currentUser: mumms.User;
  keycloak: Keycloak.KeycloakInstance;
  patient?: mumms.patient;
  pim: Pim;
  topBarHeight: number;
  logout?: () => void;
};

/** Map API codes and display labels (e.g. "Direct Care") for DIRECT_CARE checks. */
const normalizeVisitTypeForDirectCareMatch = (value: string) =>
  String(value).trim().toUpperCase().replace(/\s+/g, '_');

const patientVisitIsDirectCare = (
  visit: mumms.PatientVisit | null | undefined,
) => {
  const visitTypeCode =
    visit?.visitType ||
    (visit as mumms.PatientVisit & { visittype?: string })?.visittype;
  if (!visitTypeCode) return false;
  const normalized = normalizeVisitTypeForDirectCareMatch(visitTypeCode);
  return normalized.startsWith(DIRECT_CARE);
};

const translations: NonNullable<mumms.JSONObject> = defaults;

export const DashboardComponent = ({
  config,
  resolveUserNonRoleWidgets,
  pim,
  keycloak,
  currentUser,
  patient,
  topBarHeight,
  logout,
}: DashboardProps) => {
  const printRef = useRef<HTMLDivElement | null>(null);
  const { agency, configUserId, dashboardType } = useContext(Context);
  const { dispatch } = useContext(DashboardContext);
  const hasUserNonRoleWidgets = resolveUserNonRoleWidgets != null;
  const dashboardForSave: mumms.WidgetConfigDashboard =
    dashboardType === clinicalDashboard ? 'clinical' : 'patient';
  /** Config-service path when {@link resolveUserNonRoleWidgets} is set (api/cache). */

  const layoutDraftKey = useMemo(
    () => getWidgetLayoutDraftKey(agency, configUserId),
    [agency, configUserId],
  );

  /** Discard any stale sessionStorage draft; reload uses GET layout only (no PUT retry). */
  useEffect(() => {
    if (layoutDraftKey) {
      clearWidgetLayoutDraft(layoutDraftKey);
    }
  }, [layoutDraftKey]);

  /** Session-only layout edits when config-service palette is enabled. */
  const [
    addedPatientDashboardWidgets,
    setAddedPatientDashboardWidgets,
  ] = useState<mumms.WidgetConfig[]>([]);
  /** Layout widgets removed this session; restored to the plus menu via {@link mergedWidgetMenuConfig}. */
  const [
    removedPatientDashboardWidgets,
    setRemovedPatientDashboardWidgets,
  ] = useState<mumms.WidgetConfig[]>([]);
  /**
   * Latest {@link addedPatientDashboardWidgets} for {@link handleRemovePatientDashboardWidget}.
   * See that handler's JSDoc for Option A (deps) vs Option B (ref) rationale.
   */
  const addedPatientDashboardWidgetsRef = useRef(addedPatientDashboardWidgets);
  addedPatientDashboardWidgetsRef.current = addedPatientDashboardWidgets;

  /** Plus menu: append widget to grid layout; clear any matching removed entry. */
  const handleAddPatientDashboardWidget = useCallback(
    (selectedItem: mumms.WidgetConfig) => {
      const { componentName } = selectedItem;
      if (!componentName) {
        return;
      }
      setRemovedPatientDashboardWidgets((prev) =>
        prev.filter((w) => w.componentName !== componentName),
      );
      setAddedPatientDashboardWidgets((prev) => {
        if (prev.some((w) => w.componentName === componentName)) {
          return prev;
        }
        return [...prev, _.cloneDeep(selectedItem)];
      });
    },
    [],
  );

  /**
   * Widget header remove: drop from grid layout.
   * Session-added widgets undo {@link handleAddPatientDashboardWidget}; layout widgets go to
   * {@link removedPatientDashboardWidgets} and reappear on the plus menu.
   *
   * **Why a ref for `addedPatientDashboardWidgets` (Option B) instead of deps (Option A)?**
   *
   * Option A — put `added` in the dependency array:
   * `useCallback(..., [addedPatientDashboardWidgets])`. The handler always sees the current
   * added list, but its identity changes on every add/remove. No ref needed; perfectly valid.
   *
   * Option B — ref (this handler): {@link addedPatientDashboardWidgetsRef} is assigned
   * `addedPatientDashboardWidgets` each render; the callback uses `[]` deps so identity stays
   * stable when passed deep into the grid. Reads are fresh via `addedRef.current` (a mutable box
   * outside the closure snapshot). We chose stability over Option A so downstream tiles do not
   * re-render solely because the remove handler reference changed.
   *
   * `removed` needs no ref — updates use functional `setState` only.
   */
  const handleRemovePatientDashboardWidget = useCallback(
    (selectedItem: mumms.WidgetConfig) => {
      const { componentName } = selectedItem;
      if (!componentName) {
        return;
      }
      if (
        addedPatientDashboardWidgetsRef.current.some(
          (w) => w.componentName === componentName,
        )
      ) {
        setAddedPatientDashboardWidgets((prev) =>
          prev.filter((w) => w.componentName !== componentName),
        );
        return;
      }
      setRemovedPatientDashboardWidgets((prev) => {
        if (prev.some((w) => w.componentName === componentName)) {
          return prev;
        }
        return [...prev, _.cloneDeep(selectedItem)];
      });
    },
    [],
  );

  /**
   * Effective grid layout: API/env `config` + session added − session removed, renumbered.
   * No-op when palette is disabled (env fallback).
   */
  const mergedDashboardConfig = useMemo(() => {
    if (!hasUserNonRoleWidgets) {
      return config;
    }
    if (
      !addedPatientDashboardWidgets.length &&
      !removedPatientDashboardWidgets.length
    ) {
      return config;
    }

    const removedNames = new Set<mumms.ComponentName>(
      removedPatientDashboardWidgets
        .map((w) => w.componentName)
        .filter((n): n is mumms.ComponentName => Boolean(n)),
    );

    const layout = config
      .map((w) => _.cloneDeep(w))
      .filter((w) => !w.componentName || !removedNames.has(w.componentName));

    const seen = new Set<mumms.ComponentName>(
      layout
        .map((w) => w.componentName)
        .filter((n): n is mumms.ComponentName => Boolean(n)),
    );
    const extras = addedPatientDashboardWidgets.reduce<mumms.WidgetConfig[]>(
      (acc, w) => {
        const name = w.componentName;
        if (name && !seen.has(name) && !removedNames.has(name)) {
          seen.add(name);
          acc.push(
            _.omit(_.cloneDeep(w), 'widgetMenuOrder') as mumms.WidgetConfig,
          );
        }
        return acc;
      },
      [],
    );

    return renumberPatientDashboardWidgetMenuOrder(layout.concat(extras));
  }, [
    config,
    addedPatientDashboardWidgets,
    removedPatientDashboardWidgets,
    hasUserNonRoleWidgets,
  ]);

  const hasSessionLayoutEdits =
    addedPatientDashboardWidgets.length > 0 ||
    removedPatientDashboardWidgets.length > 0;

  const clearSessionLayoutEdits = useCallback(() => {
    setAddedPatientDashboardWidgets([]);
    setRemovedPatientDashboardWidgets([]);
    if (layoutDraftKey) {
      clearWidgetLayoutDraft(layoutDraftKey);
    }
  }, [layoutDraftKey]);

  const handlePersistRetriesExhausted = useCallback(() => {
    dispatch({
      type: SET_ALERT,
      payload: {
        text:
          'Unable to save your dashboard layout. Changes are kept on this device; try editing again.',
        severity: 'error',
      },
    });
  }, [dispatch]);

  /**
   * Persist session add/remove to config-service (USER layout PUT).
   *
   * **While editing:** {@link mergedDashboardConfig} is what the grid shows (optimistic).
   * **This hook:** after {@link hasSessionLayoutEdits}, debounces ~1.5s then PUTs that
   * layout via {@link usePersistPatientDashboardWidgetLayout}. Stale responses (user edited
   * again during flight) are ignored so optimistic UI stays correct.
   *
   * **On fresh PUT success:** root Dashboard `onDashboardLayoutSaved` merges
   * server layout into `context.config` + cache; {@link clearSessionLayoutEdits} clears
   * `added` / `removed` so the saved layout becomes the new baseline.
   *
   * **No-op when** `enabled` is false (env fallback — no config-service path).
   * Reload shows GET layout only; unsaved in-session edits are not retried via PUT.
   *
   * @see usePersistPatientDashboardWidgetLayout
   */
  usePersistPatientDashboardWidgetLayout({
    /** API/cache path only; env fallback never PUTs. */
    enabled: hasUserNonRoleWidgets,
    dashboard: dashboardForSave,
    /** Layout to save: API/env `config` + session added − session removed. */
    mergedDashboardConfig,
    /** True when `added` or `removed` session lists are non-empty. */
    hasSessionLayoutEdits,
    /** After non-stale save: drop session deltas (baseline now in context). */
    onPersistSuccess: clearSessionLayoutEdits,
    onPersistRetriesExhausted: handlePersistRetriesExhausted,
  });

  /**
   * Plus menu source: API palette plus layout widgets removed this session (not already on palette).
   */
  const mergedWidgetMenuConfig = useMemo(() => {
    if (!hasUserNonRoleWidgets) {
      return [];
    }
    const palette = resolveUserNonRoleWidgets ?? [];
    const paletteNames = new Set<mumms.ComponentName>(
      palette
        .map((w) => w.componentName)
        .filter((n): n is mumms.ComponentName => Boolean(n)),
    );
    const restoredToPalette = removedPatientDashboardWidgets.filter(
      (w) => w.componentName && !paletteNames.has(w.componentName),
    );
    return [
      ...palette.map((w) => _.cloneDeep(w)),
      ...restoredToPalette.map((w) => _.cloneDeep(w)),
    ];
  }, [
    hasUserNonRoleWidgets,
    resolveUserNonRoleWidgets,
    removedPatientDashboardWidgets,
  ]);

  const { idgMeeting, visitAttributes } = useContext(Context);
  const {
    pdfProgressNotes,
    pdfPSOComponents,
    asyncPdfDataReady,
    pdfRgHash,
    pdfRgHashPrint,
    pdfCpfNotes,
    pdfCarePlanProblems,
    pdfMedications,
    pdfMedicationsNotes,
    pdfBereavNotes,
    pdfFacesheetData,
    pdfCareGiversInfo,
    dispatchReactPDF,
    pdfCertAppSnapshot,
    pdfMeasuresGraphImages,
    jsonMeasures,
    historicalRows,
    pdfWeeklyTasks,
    includePdfTasksNotes,
    pdfTasksNotes,
  } = useContext(MummsPDFGlobalContext);
  const { cppNotesGlobal } = useContext(CPPGlobalContext);
  const { appVisit, measuresGlobal, levelOfCare } = useContext(GlobalContext);
  const { patientCertHistory } = useContext(CertGlobalContext);
  const { availableHOPEActions, isOtherInProgHopeVisit } = useContext(
    HopeGlobalContext,
  );
  const { idgRenderInstructions } = useContext(PimMessagingContext);

  const {
    printInterfaceOpen,
    printLayoutOpen,
    dashboardPrintConfig,
    alertInfo,
    themeOverlay,
    disablePrintIcon,
  } = useContext(DashboardContext);
  const {
    dispatchVisit,
    visitOpen,
    minimizeVisitDialog,
    updatePatientVisit,
    visitTitle,
    showTasks,
    alertVisitInfo,
    numPatientTasks,
    userTasks,
    timeRequest,
    savedVisit,
    initSavedVisit,
    IPUVisit,
    hydrateInProgressVisitFromLog,
    hydrateDocumentVisitFromLog,
    openedFromVisitLogReopen,
    closingPriorVisit,
  } = useContext(VisitContext);
  const { hcpcsPermission, dispatchHCPCS, showVisitLoader } = useContext(
    HCPCSContext,
  );

  const setReopenVisitDashboardLoader = useCallback(
    (show: boolean) => {
      dispatchHCPCS({
        type: SHOW_VISIT_LOADER,
        payload: show,
      });
    },
    [dispatchHCPCS],
  );

  const generalAlert = alertInfo || alertVisitInfo;
  const hasPatientEpisodes =
    patient && patient?.episodes?.length && patient?.episodes?.length > 1;
  const showEpisodes =
    hasPatientEpisodes && !savedVisit && levelOfCare !== priorVisit;

  const isPriorVisitMode = levelOfCare === priorVisit;

  const isDirectCareVisit = patientVisitIsDirectCare(savedVisit);
  // HOPE chip element from SIAModal: the prompt stack anchors to it whenever
  // it mounts (on Visit Log reopen it can mount after the HOPE prompt flag).
  const [hopeChipEl, setHopeChipEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (alertInfo) {
      // if user does not click on close, the context won't get updated
      setTimeout(() => {
        dispatch({
          type: SET_ALERT,
          payload: null,
        });
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertInfo]);

  useEffect(() => {
    if (alertVisitInfo) {
      // if user does not click on close, the context won't get updated
      setTimeout(() => {
        dispatchVisit({
          type: SET_VISIT_ALERT,
          payload: null,
        });
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertVisitInfo]);

  // stop theme overlay from showing
  useEffect(() => {
    if (themeOverlay) {
      setTimeout(() => {
        dispatch({
          type: SET_THEME_OVERLAY,
          payload: false,
        });
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeOverlay]);

  const dashboardConfig = _.cloneDeep(mergedDashboardConfig);
  const dashboardWidgetMenuConfig = _.cloneDeep(mergedWidgetMenuConfig);

  // Get agency bin for filtering
  const agencyToCheck = currentUser.isMumms
    ? agency
    : currentUser.currentHospiceBin;

  // If agencies in list, do not filter out beta widgets
  const betaWidgetBins: string = window.env?.betaWidgetBins as string;
  let betaWidgetBinsAry: string[] = [];
  if (betaWidgetBins) {
    betaWidgetBinsAry = betaWidgetBins.split(',');
  }
  const betaStatus =
    agencyToCheck === null
      ? false
      : betaWidgetBinsAry.includes('*') ||
        betaWidgetBinsAry.includes(agencyToCheck);
  const betaConfig = betaStatus
    ? dashboardConfig
    : dashboardConfig.filter((w: mumms.WidgetConfig) => w.beta === false);
  const betaWidgetMenuConfig = betaStatus
    ? dashboardWidgetMenuConfig
    : dashboardWidgetMenuConfig.filter(
        (w: mumms.WidgetConfig) => w.beta === false,
      );

  // Filter out any widgets according to per-widget config
  const nonHiddenConfig =
    agencyToCheck === null
      ? betaConfig
      : betaConfig.filter((w: mumms.WidgetConfig) => {
          const showForBinsAry: string[] = w.showForBins?.split(',') || [];
          const hideForBinsAry: string[] = w.hideForBins?.split(',') || [];
          let hideWidget = false;

          hideWidget =
            hideForBinsAry?.includes(agencyToCheck) ||
            (hideForBinsAry?.includes('*') &&
              !showForBinsAry?.includes(agencyToCheck));

          return !hideWidget;
        });
  const nonHiddenWidgetMenuConfig =
    agencyToCheck === null
      ? betaWidgetMenuConfig
      : betaWidgetMenuConfig.filter((w: mumms.WidgetConfig) => {
          const showForBinsAry: string[] = w.showForBins?.split(',') || [];
          const hideForBinsAry: string[] = w.hideForBins?.split(',') || [];
          let hideWidget = false;

          hideWidget =
            hideForBinsAry?.includes(agencyToCheck) ||
            (hideForBinsAry?.includes('*') &&
              !showForBinsAry?.includes(agencyToCheck));

          return !hideWidget;
        });

  // re-number widgetMenuOrder values (NaN-safe sort; always assign index — avoids
  // skipping numeric 0 and unstable ordering when `widgetMenuOrder` is missing)
  const newConfig = [...nonHiddenConfig]
    .sort(compareWidgetMenuOrder)
    .map((w: mumms.WidgetConfig, index) => {
      w.widgetMenuOrder = index;
      return w;
    });

  // doNotShow widgets (Facesheet, Forms): excluded from grid and + menu but kept in
  // layout config for watermark / OpenShift access; opened from sidebar ribbon instead
  // (FacesheetMenu upper, FormListMenu lower). Still persisted on save — see
  // pickDoNotShowLayoutWidgets / buildPatientDashboardLayoutForSave in widgetConfig.
  const dashboardGridConfig = [...newConfig]
    .filter((w: mumms.WidgetConfig) => !w.doNotShow)
    .sort(compareWidgetMenuOrder);
  const widgetMenuOnlyConfig = [...nonHiddenWidgetMenuConfig]
    .filter((w: mumms.WidgetConfig) => !w.doNotShow)
    .sort(compareWidgetMenuOrder);

  const dashboardGridComponentNames = new Set<mumms.ComponentName>(
    dashboardGridConfig
      .map((w) => w.componentName)
      .filter((n): n is mumms.ComponentName => Boolean(n)),
  );
  const patientDashboardPlusMenuConfig = widgetMenuOnlyConfig.filter(
    (w) => w.componentName && !dashboardGridComponentNames.has(w.componentName),
  );

  /** Remove when config-service is active and more than one visible grid widget remains. */
  const canRemovePatientDashboardWidget =
    hasUserNonRoleWidgets && dashboardGridConfig.length > 1;

  // filter printable widgets
  const toPrintConfig = [...newConfig].filter((w) => w.printable === true);
  const printInterfaceConfig = toPrintConfig.sort(
    (a: mumms.WidgetConfig, b: mumms.WidgetConfig) =>
      (a.printMenuOrder ?? Number.POSITIVE_INFINITY) -
      (b.printMenuOrder ?? Number.POSITIVE_INFINITY),
  );
  const printConfigNames: Record<mumms.ComponentName, string> = [
    ...toPrintConfig,
  ].reduce((seed: any, widget: mumms.WidgetConfig) => {
    seed[widget.componentName] = widget.widgetName;
    return seed;
  }, {});

  let idgConfigMasterConfig: any;

  const closePrintDialog = () => {
    // reset the default state for the printicon when the PrintDialog closes.
    dispatch({
      type: SET_DISABLE_PRINT,
      payload: true,
    });
    dispatch({
      type: SET_PRINT_LAYOUT_OPEN,
      payload: false,
    });
    clearPdfData(dispatchReactPDF);
  };

  const closePrintInterface = () => {
    dispatch({
      type: SET_PRINT_INTERFACE_OPEN,
      payload: false,
    });
    dispatch({
      type: SET_LOADER,
      payload: false,
    });
    closePrintDialog();
  };

  const onMinimizeVisit = () =>
    dispatchVisit({
      type: MINIMIZE_VISIT_DIALOG,
      payload: true,
    });

  const Alert = (props: AlertProps) => (
    <MuiAlert elevation={6} variant="filled" {...props} />
  );
  const handleClose = () => {
    dispatch({
      type: SET_ALERT,
      payload: null,
    });
    dispatchVisit({
      type: SET_VISIT_ALERT,
      payload: null,
    });
  };

  const onTasksClick = () => {
    // toggle
    if (showTasks) {
      // do nothing
    } else {
      dispatchVisit({
        type: SHOW_TASKS,
        payload: true,
      });
    }
  };

  const getTasks = () => {
    const showIcon =
      userTasks && userTasks.length && !timeRequest && savedVisit;
    return showIcon ? (
      <TasksIcon numTasks={numPatientTasks} onTasksClick={onTasksClick} />
    ) : null;
  };

  const getAttributes = () => (
    <AttributesIcon
      visitAttributes={visitAttributes}
      appVisit={appVisit}
      onSubmit={async () => {
        if (!patient?.patientNumber || !initSavedVisit) {
          return false;
        }
        const saved = await updatePatientVisit(patient.patientNumber, {
          ...initSavedVisit,
          visitAttributes,
        });
        if (!saved) {
          dispatchVisit({
            type: SET_VISIT_ALERT,
            payload: {
              text: defaults.visitSaveError,
              severity: 'error',
            },
          });
          return false;
        }
        return true;
      }}
    />
  );

  // VisitPromptStack goes first so its popup mounts after the visit dialog
  // (stacks above it) and before the SIA menu (stays below SIA).
  const getHopeIcon = () => (
    <>
      <VisitPromptStack hopeChip={hopeChipEl} />
      {isDirectCareVisit ? (
        <SIAModal
          milestonesAvailable={!!availableHOPEActions}
          hopeDisabled={!!isOtherInProgHopeVisit}
          onHopeIconRef={setHopeChipEl}
        />
      ) : null}
    </>
  );

  const getEaIcon = () => <ElectionAddendumIcon />;

  const showHCPCSIcon =
    savedVisit &&
    ((!IPUVisit && hcpcsPermission && hcpcsPermission.ishcpcsallowed) || false);

  const onClickHCPCS = () => {
    dispatchHCPCS({
      type: SET_SHOW_HCPCS,
      payload: true,
    });
  };

  const getHCPCSIcon = () =>
    showHCPCSIcon ? <HCPCSIcon onClick={onClickHCPCS} /> : null;

  const mainPrintConfig = dashboardPrintConfig && {
    ...dashboardPrintConfig,
  };

  mainPrintConfig && delete mainPrintConfig?.fromDate;
  mainPrintConfig && delete mainPrintConfig?.toDate;
  const printWidgetConfig: mumms.PrintWidgetConfigInterface | null = mainPrintConfig && {
    ...mainPrintConfig,
  };

  // widgetConfig is array of componentName to generatePrintGrid
  const widgetConfig = printWidgetConfig
    ? Object.keys(printWidgetConfig).filter(
        (key) => (printWidgetConfig as any)[key],
      )
    : null;

  // ===== Visit Interface Dashboard Functions =======

  const visitDialogOpen =
    !!visitOpen && !minimizeVisitDialog && !closingPriorVisit;
  /** Full-screen blocking overlay for visit-log reopen (PIM + hydrate + RecordVisit load). */
  const showReopenVisitBlockingLoader =
    closingPriorVisit ||
    (showVisitLoader && (openedFromVisitLogReopen || !visitDialogOpen));

  const appVisitHasSavedHCPCSForHeader = !!(
    (appVisit as { physicianServices?: unknown[] } | undefined)
      ?.physicianServices?.length ||
    (savedVisit as { physicianServices?: unknown[] } | null)?.physicianServices
      ?.length
  );

  const recordVisitHeaderHCPCS =
    visitDialogOpen && appVisitHasSavedHCPCSForHeader ? (
      <HCPCSIcon
        onClick={() =>
          dispatchHCPCS({
            type: SET_SHOW_HCPCS,
            payload: true,
          })
        }
      />
    ) : undefined;

  /** Document-on-visit (`priorVisit`): orange title bar only — no header icons. */
  const visitDialogHeaderExtras = isPriorVisitMode
    ? {}
    : {
        episode: showEpisodes ? (
          <EpisodeCheck episodes={patient?.episodes} />
        ) : undefined,
        tasks: getTasks(),
        attributes: getAttributes(),
        hope: getHopeIcon(),
        ea: getEaIcon(),
        hcpcs: recordVisitHeaderHCPCS ?? getHCPCSIcon(),
      };

  // ==========

  // @note we need the Widget Global Contexts up because PRINT AND GRID
  // TODO move the code to a diff file

  const getDoc = () => (
    <DashboardPDFDocument
      patient={patient}
      currentUser={currentUser}
      widgetConfig={widgetConfig}
      rgHash={pdfRgHash}
      rgHashPrint={pdfRgHashPrint}
      dashboardPrintConfig={dashboardPrintConfig}
      patientCertHistory={patientCertHistory}
      cpfNotes={pdfCpfNotes}
      cppNotesGlobal={cppNotesGlobal}
      pdfCarePlanProblems={pdfCarePlanProblems}
      pdfProgressNotes={pdfProgressNotes}
      pdfPSOComponents={pdfPSOComponents}
      pdfCertAppSnapshot={pdfCertAppSnapshot}
      pdfMeasuresGraphImages={pdfMeasuresGraphImages}
      measuresGlobal={measuresGlobal}
      pdfMedications={pdfMedications}
      pdfMedicationsNotes={pdfMedicationsNotes}
      pdfBereavNotes={pdfBereavNotes}
      pdfFacesheetData={pdfFacesheetData}
      pdfCareGiversInfo={pdfCareGiversInfo}
      jsonMeasures={jsonMeasures}
      historicalRows={historicalRows}
      pdfWeeklyTasks={pdfWeeklyTasks}
      includePdfTasksNotes={includePdfTasksNotes}
      pdfTasksNotes={pdfTasksNotes}
      sourceString={PrintTheChart}
    />
  );

  useEffect(() => {
    const allAsyncPDFDataRetrieved =
      widgetConfig &&
      widgetConfig.every((component) =>
        asyncPdfDataReady.includes(component as string),
      );
    if (allAsyncPDFDataRetrieved && printInterfaceOpen) {
      printPDF(getDoc, patient).then(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
        dispatch({
          type: SET_PRINT_INTERFACE_OPEN,
          payload: false,
        });
        closePrintDialog();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asyncPdfDataReady]);

  return (
    <ElectionAddendumProvider>
      <DashboardMain id="dashboard-main">
        <SideBar
          config={dashboardGridConfig}
          resolveUserNonRoleWidgets={patientDashboardPlusMenuConfig}
          onAddPatientDashboardWidget={
            hasUserNonRoleWidgets ? handleAddPatientDashboardWidget : undefined
          }
          topBarHeight={topBarHeight}
        />
        {themeOverlay && <ThemeLoader />}
        <GridDiv>
          <DashboardGridComponent
            pim={pim}
            keycloak={keycloak}
            logout={logout}
            currentUser={currentUser}
            patient={patient}
            config={dashboardGridConfig}
            onRemovePatientDashboardWidget={
              canRemovePatientDashboardWidget
                ? handleRemovePatientDashboardWidget
                : undefined
            }
            topBarHeight={topBarHeight}
            printConfigNames={printConfigNames}
            dashboardPrintConfig={
              (dashboardPrintConfig ||
                idgConfigMasterConfig) as mumms.PrintConfigInterface
            }
            hydrateInProgressVisitFromLog={hydrateInProgressVisitFromLog}
            hydrateDocumentVisitFromLog={hydrateDocumentVisitFromLog}
            setReopenVisitDashboardLoader={setReopenVisitDashboardLoader}
          />
        </GridDiv>
        {idgRenderInstructions && (
          <IDGRenderDialog instructions={idgRenderInstructions} />
        )}
        <PrintInterfaceDialog
          open={!!printInterfaceOpen}
          handleClick={closePrintInterface}
          config={printInterfaceConfig}
          printConfigNames={printConfigNames}
        />
        <VisitDialogBox
          title={(visitTitle as any) || defaults.createVisit}
          headerColor={isPriorVisitMode ? 'orange' : undefined}
          disableBackdropClick
          open={visitDialogOpen}
          draggable
          hideBackdrop
          disableScrollLock
          // todo refactor
          layout=""
          {...visitDialogHeaderExtras}
          handleClick={onMinimizeVisit}
        >
          <VisitInterface key="visitMenu" />
        </VisitDialogBox>
        <AddHCPCSDialog />
        <HopeVisitWarningModal />
        <TaskDialogBox
          title={(visitTitle as any) || defaults.createVisit}
          disableBackdropClick
          open={showTasks}
          hideBackdrop
          disableScrollLock
          layout=""
          tasks={getTasks()}
          save={<SubmitTasks />}
        >
          <TaskPlanning />
        </TaskDialogBox>

        {widgetConfig &&
          !(widgetConfig as mumms.ComponentName[]).every((component) =>
            CompletedPDFComponents.includes(component),
          ) && (
            <ReactToPrint
              content={() => printRef.current}
              pageStyle={pageStyle}
            >
              <PrintContextConsumer>
                {({ handlePrint }) => (
                  <DialogBox
                    title={translations.printDialog as string}
                    disableBackdropClick
                    open={!!printLayoutOpen}
                    handleClick={closePrintDialog}
                    fullWidth
                    maxWidth="lg"
                    disableScrollLock
                    onPrint={handlePrint}
                    disablePrint={disablePrintIcon}
                    minHeight
                  >
                    <DashboardPrintComponent
                      dashboardPrintConfig={
                        dashboardPrintConfig as mumms.PrintConfigInterface
                      }
                      printConfigNames={printConfigNames}
                      ref={printRef}
                    />
                  </DialogBox>
                )}
              </PrintContextConsumer>
            </ReactToPrint>
          )}
        <Snackbar
          open={!!generalAlert}
          autoHideDuration={3000}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={handleClose} severity={generalAlert?.severity}>
            {generalAlert?.text}
          </Alert>
        </Snackbar>
        {showReopenVisitBlockingLoader && <OverlayLoader />}
      </DashboardMain>
    </ElectionAddendumProvider>
  );
};
export default DashboardComponent;
